<div class="tae">
  <div class="toolbar" style="margin-bottom: 8px; display: flex; gap: 8px">
    <button class="primary" (click)="play()">Play</button>
    <button (click)="openJson()">Edit JSON</button>
  </div>

  <nw-text-animation-step-json-modal
    *ngIf="jsonOpen"
    [value]="baseStep"
    (save)="applyJson($event)"
    (cancel)="closeJson()"
  ></nw-text-animation-step-json-modal>
</div>
